/**
 * LensTrove product-card swatches
 * - Hover a swatch → preview that color's hero image on the card.
 * - Mouse leaves the card → revert to the default image.
 * - Click a swatch → navigate to the product page with that variant preselected.
 */
(function () {
  function init() {
    // For each card: pick a random swatch (so listing pages don't always lead
    // with the first variant), apply its image/color/link, and remember THAT
    // as the card's origin so mouseleave reverts to the randomly-chosen color.
    document.querySelectorAll('.lt-card').forEach(function (card) {
      var img = card.querySelector('.lt-card__img');
      if (!img || card.dataset.swatchBound) return;
      card.dataset.swatchBound = '1';

      var swatches = card.querySelectorAll('[data-swatch]');
      var defaultIdx = 0;
      if (swatches.length > 1) {
        var pick = swatches[Math.floor(Math.random() * swatches.length)];
        var pickImg = pick.getAttribute('data-img');
        var pickColor = pick.getAttribute('data-color');
        var pickUrl = pick.getAttribute('data-variant-url');
        if (pickImg) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = pickImg;
          card.dataset.origSrc = pickImg;
        }
        var colorEl = card.querySelector('[data-card-color]');
        if (colorEl && pickColor) colorEl.textContent = pickColor;
        if (pickUrl && card.tagName === 'A') card.href = pickUrl;
        swatches.forEach(function (s, i) {
          var active = s === pick;
          s.classList.toggle('is-active', active);
          if (active) defaultIdx = i;
        });
      }

      card.addEventListener('mouseleave', function () {
        var orig = card.dataset.origSrc;
        if (orig) {
          img.src = orig;
        }
        var list = card.querySelectorAll('[data-swatch]');
        list.forEach(function (s, i) { s.classList.toggle('is-active', i === defaultIdx); });
      });
    });

    document.addEventListener('mouseover', onSwatchHover);
    document.addEventListener('focusin', onSwatchHover);
    document.addEventListener('click', onSwatchClick);
    document.addEventListener('keydown', onSwatchKey);
  }

  function onSwatchHover(e) {
    var sw = e.target.closest('[data-swatch]');
    if (!sw) return;
    var card = sw.closest('.lt-card');
    if (!card) return;
    var img = card.querySelector('.lt-card__img');
    if (!img) return;
    if (!card.dataset.origSrc) card.dataset.origSrc = img.currentSrc || img.src;
    var newImg = sw.getAttribute('data-img');
    if (newImg) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = newImg;
    }
    var colorEl = card.querySelector('[data-card-color]');
    var name = sw.getAttribute('data-color');
    if (colorEl && name) colorEl.textContent = name;
    card.querySelectorAll('[data-swatch]').forEach(function (s) {
      s.classList.toggle('is-active', s === sw);
    });
  }

  function onSwatchClick(e) {
    var sw = e.target.closest('[data-swatch]');
    if (!sw) return;
    var url = sw.getAttribute('data-variant-url');
    if (!url) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  }

  function onSwatchKey(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var sw = document.activeElement && document.activeElement.closest('[data-swatch]');
    if (!sw) return;
    e.preventDefault();
    var url = sw.getAttribute('data-variant-url');
    if (url) window.location.href = url;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
